import { CartLineItem as LineItemType } from 'types/checkout'
import { MTO_BUNDLE_FLAG } from '@consts/index'
import { removeSubdomainInUrl } from '@helpers/utils'

export const getBundleId = (item: LineItemType) => {
  return item.attributes.find(attribute => attribute.key === MTO_BUNDLE_FLAG)
    ?.value
}

export function getBundleRole(item: LineItemType): string | undefined {
  return item.attributes?.find(attr => attr.key === '_MTObundleRole')?.value
}

export const getBundledItems = (lineItems: LineItemType[]) => {
  return lineItems.reduce((result: Record<string, LineItemType[]>, item) => {
    const bundleId = getBundleId(item)

    if (!bundleId) return result

    if (!result[bundleId]) {
      result[bundleId] = []
    }

    result[bundleId].push(item)

    // Simple ordering: primary first
    result[bundleId].sort((a, b) => {
      const roleA = getBundleRole(a)
      const roleB = getBundleRole(b)

      if (roleA === 'primary') return -1 // If A is primary → put A first (-1)
      if (roleB === 'primary') return 1 // If B is primary → put B first (1)
      return 0
    })

    return result
  }, {} as Record<string, LineItemType[]>)
}

export const getLineItemProperties = (item: LineItemType) => {
  return {
    itemId: item.id,
    inventoryQuantity: item.merchandise.quantityAvailable,
    image: item.merchandise.image ? item.merchandise.image.url : '',
    productTitle: item.merchandise.product.title,
    productType: item.merchandise.product.productType,
    price: item.merchandise.price,
    compareAtPrice: item.merchandise.compareAtPrice,
    quantity: item.quantity,
    properties: item.attributes,
    discounts: item.discountAllocations,
    productTags: item.merchandise.product.tags,
    url: removeSubdomainInUrl(item.merchandise.product.url)
  }
}
